<script setup>
import { computed, inject, ref, watch } from 'vue';
import { default as t } from '../../translations/translationStrings';

// Props.
const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  s12yData: {
    required: true,
    type: Object,
    default: () => ({
      greenhouseGasEfficiency: true,
      waterEfficiency: true,
      nutrientUseEfficiency: true,
    }),
  },
});

// Data.
const activeSlice = ref('greenhouseGasEfficiency');

// Computed.
const sliceKeys = computed(() => {
  return Object.keys(props.s12yData).filter((key) => props.s12yData[key]);
});

const pieClass = computed(() => {
  return sliceKeys.value.length === 2
    ? 'halves'
    : sliceKeys.value.length === 3
    ? 'thirds'
    : '';
});

// Events.
const emit = defineEmits(['selectSlice']);

// Methods.
const selectSlice = (key) => {
  activeSlice.value = key;
  emit('selectSlice', key);
};

// Inject openAccordionKey and attach a watcher to keep it in-sync with activeSlice.
if (props.type === 'interactive') {
  const openAccordionKey = inject('openAccordionKey');

  watch(openAccordionKey, (newKey) => {
    if (activeSlice.value !== newKey) {
      activeSlice.value = newKey;
    }
  });
}
</script>

<template>
  <div
    v-if="sliceKeys.length"
    class="s12y-pie"
    :class="{
      [`s12y-pie--${type}`]: type,
      [`s12y-pie--${pieClass}`]: pieClass,
    }">
    <template v-for="key in sliceKeys" :key="key">
      <div
        class="s12y-pie__slice"
        :class="[
          `s12y-pie__slice--${key}`,
          activeSlice === key ? 's12y-pie__slice--active' : '',
        ]"
        :title="t.sustainableApplicationExplanation[key].headline"
        @click="selectSlice(key)">
        <img
          :src="`/${require(`../../../images/s12y-icons/icon-${key}.svg`)}`"
          alt=""
          class="s12y-pie__slice-icon" />
      </div>
    </template>
  </div>
</template>
